import { useMutation } from '@tanstack/react-query';
import { useUserState } from '../../hooks/context/useUserState';
import { requestMenu } from '../requests/requestMenu';
import { SET_MENU_ITEMS } from '../../constants';

type getMenuArgs = {
  menuId: string;
  sessionToken: string;
};

export const useMenu = () => {
  const { dispatch } = useUserState();

  const mapItems = (items, blockIndex) =>
    items
      .filter((item: any) => item.visible !== false)
      .map((item, index) => {
        if (item.type === 'submenu') {
          const subMenuKey = `${blockIndex}_${index}`;
          const subItems = mapItems(item.menuItems, subMenuKey);
          return {
            label: item.label,
            children: subItems,
            type: item.type,
            key: subMenuKey,
          };
        }
        const isDatasetLink =
          item.action?.type === 'dataset' && item.action?.datasetId;
        const isFormLink = item.action?.type === 'form' && item.action?.formId;
        const isAppLink = item.action?.type === 'app' && item.action?.link;
        const appId = isAppLink
          ? String(item.action?.appId || `${blockIndex}_${index}`)
          : undefined;
        return {
          label: item.label || undefined,
          type: item.type,
          url: isDatasetLink ? item.action?.datasetId : undefined,
          formId: isFormLink ? item.action?.formId : undefined,
          appId,
          app: isAppLink
            ? { link: String(item.action.link), params: item.action.params }
            : undefined,
        };
      });

  const { error, mutateAsync: getMenu } = useMutation({
    mutationFn: ({ sessionToken, menuId }: getMenuArgs) =>
      requestMenu(menuId, sessionToken),
    onSuccess: async (response) => {
      const menuItems = response.menuBlocks
        .filter((menuBlock: any) => menuBlock.visible !== false)
        .map((menuBlock, index) => ({
          label: menuBlock.label,
          key: index.toString(),
          icon: menuBlock.icon || undefined,
          children: [...mapItems(Object.values(menuBlock.menuItems), index)],
        }))
        .filter((menuBlock) => menuBlock.children?.length);
      dispatch({ type: SET_MENU_ITEMS, payload: menuItems });
    },
  });

  return { error, getMenu };
};
